module.exports = __webpack_public_path__ + "0b8667db4a4e966d28a6206c90fab90b.svg";